import { render } from "./EventLogs.vue?vue&type=template&id=aea6fa54"
import script from "./EventLogs.vue?vue&type=script&lang=js"
export * from "./EventLogs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__